import React from "react";

import bgImg from "images/19.jpg";

const Company = () => {
	return (
		<div style={{ background: "#f7f7f7" }}>
			<div
				className="rts-more-about-company-cleaning rts-section-gap"
				style={{ backgroundImage: `url(${bgImg})` }}>
				<div className="container">
					<div className="row">
						<div className="col-xl-7 col-lg-12 mt--100 mt_sm--0 mt_md--0">
							<div className="title-area-left">
								<p className="pre">Cosa facciamo per te</p>
								<h2 className="title">
									Dalle idee,
									<br />
									alla realizzazione
								</h2>
							</div>
							<div className="row g-24 mt--30">
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<div className="single-solution-start-cleaning">
										<div className="icon">
											<i className="fa-light fa-3x fa-block-brick" style={{ color: "#128745" }} />
										</div>
										<div className="inner-content">
											<h6 className="title">Pareti in cartongesso</h6>
											<p className="disc">
												Soluzioni su misura per dividere e ottimizzare gli spazi interni con finiture di
												alta qualità
											</p>
										</div>
									</div>
								</div>
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<div className="single-solution-start-cleaning">
										<div className="icon">
											<i className="fa-light fa-3x fa-chimney" style={{ color: "#128745" }} />
										</div>
										<div className="inner-content">
											<h6 className="title">Controsoffitti in cartongesso</h6>
											<p className="disc">
												Estetica e funzionalità: abbassamenti, velette e design moderni per ogni
												ambiente
											</p>
										</div>
									</div>
								</div>
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<div className="single-solution-start-cleaning">
										<div className="icon">
											<i className="fa-light fa-3x fa-ear-muffs" style={{ color: "#128745" }} />
										</div>
										<div className="inner-content">
											<h6 className="title">Isolamento Termico e Acustico</h6>
											<p className="disc">
												Comfort garantito con materiali isolanti performanti per una casa più efficiente
											</p>
										</div>
									</div>
								</div>
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<div className="single-solution-start-cleaning">
										<div className="icon">
											<i className="fa-light fa-3x fa-lightbulb" style={{ color: "#128745" }} />
										</div>
										<div className="inner-content">
											<h6 className="title">Ristrutturazioni per Interni</h6>
											<p className="disc">
												Dalla progettazione alla realizzazione: rinnoviamo i tuoi ambienti con cura e
												professionalità
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Company;
